import * as $ from 'jquery';

let totalInitializedButtons = 0;

function updateButtonAriaLabel(button: Element) {
	button.setAttribute('aria-label',
		button.querySelector<HTMLElement>(`.view${button.getAttribute('aria-expanded') === 'true' ? 'Less' : 'More'}`)?.innerText ?? "");
}

const initializeButton = (button: HTMLElement) => {
	const target = button.nextElementSibling;
	if (!(target instanceof HTMLElement)) {
		return;
	}
	if (!target.id) {
		target.id = `partially-hidden-toggle-button-target-${totalInitializedButtons}`;
	}
	target.classList.add('partially-hidden-toggle-button-target');

	if (button.getAttribute('aria-expanded') !== 'true') {
		target.style.display = 'none';
	}
	target.after(button);
	updateButtonAriaLabel(button);
	button.classList.remove('uninitialized');

	button.setAttribute('aria-controls', target.id);
	button.addEventListener('click', () => {
		if (button.getAttribute('aria-expanded') === 'true') {
			//Collapse the "accordion"
			button.setAttribute('aria-expanded', 'false');
			updateButtonAriaLabel(button);
			$(target).slideUp();
		} else {
			//Expand the "accordion"
			button.setAttribute('aria-expanded', 'true');
			updateButtonAriaLabel(button);
			$(target).slideDown();
		}
	});

	totalInitializedButtons++;
};

document.querySelectorAll<HTMLElement>('.partiallyHiddenBlockToggle').forEach(initializeButton);
new MutationObserver(mutations => {
	for (const mutation of mutations) {
		for (const addedNode of mutation.addedNodes) {
			if (addedNode instanceof HTMLElement) {
				addedNode.querySelectorAll<HTMLElement>('.partiallyHiddenBlockToggle').forEach(initializeButton);
			}
		}
	}
}).observe(document, {subtree: true, childList: true});
